import theme from "theme";

const { default: styled } = require("@emotion/styled");

const CardContainerStyle = styled.div`
  margin: auto;
  padding: 16px;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 5px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 10px 5px 10px 0px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 5px;
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #333333;
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.2;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;

  @media (max-width: 600px) {
    margin-bottom: 5px;
    font-size: 10px;
    flex: 0.5;
  }
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  padding: 0px 15px 0px 15px;
  margin: 0px 0px 15px 0px;

  @media (max-width: 600px) {
    // flex-direction: column;
    // align-items: flex-start;
  }
`;

const Children = styled.div`
  flex: 1.2;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
  width: 35%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const ActivateDiv = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const Span = styled.span`
  font-size: 14px;

  @media (max-width: 600px) {
    font-size: 8px;
  }
`;

const SC = {
  CardContainerStyle,
  HeaderStyle,
  HeaderContainer,
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  ActivateDiv,
  Span,
};

export default SC;
